import React from 'react';
import { Box } from '@mui/material';
import SpeedIcon from '@mui/icons-material/Speed';
import MoneyOffIcon from '@mui/icons-material/MoneyOff';
import FaceRetouchingNaturalIcon from '@mui/icons-material/FaceRetouchingNatural';
import IconListItem from '../IconListItem';

const AutopayBenefits = () => (
  <Box sx={{
    display: 'flex', flexDirection: 'column', gap: 2, alignItems: 'center',
  }}
  >
    <IconListItem
      Icon={SpeedIcon}
      text="Consistent on-time payments may help you maintain or improve your credit score."
    />
    <IconListItem
      Icon={MoneyOffIcon}
      text="On-time payments prevent late fees from increasing your overall loan cost."
    />
    <IconListItem
      Icon={FaceRetouchingNaturalIcon}
      text="Peace of mind knowing your payment is predictable and scheduled each month."
    />
  </Box>
);

export default AutopayBenefits;
